import * as _ from 'lodash'
import {IBusinessObject, IBusinessObjectChanges, IBusinessObjectChangesOptions} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {WB_DomainItemRow, WB_DomainRow, WB_DomainTextRow} from "../PA.Core/PAdbSchemaRows";
import {IwbDomain} from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_Domain,
    esWB_Domain_Item,
    esWB_Domain_Text
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {RecordUtils} from "../PA.Core/Basic/Records";
import {DefaultChanges} from "../PA.Core/BusinessObject/BusinessObjectChanges";

export class DomainBO implements IBusinessObject
{
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_Domain: WB_DomainRow;

    constructor(options?: any) {

        this.CreateOptions = options || {};

        if('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New Domain'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = null;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_Domain = null;
    }

    get WB_Domain(): WB_DomainRow
    {
        return this.drWB_Domain;
    }


    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: object): Promise<IBusinessObject> {
        var self = this;
        this.LoadProgressProvider.start("Creating Domain");
        this._OnLoadComplete = new Promise<IBusinessObject>( (resolve, error) => {

            self.LoadOptions = options || {};
            if('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if(this.dbContext == null) {
                var sError = "Unable to determine dbContext for new Domain.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            // Create record using dbContext
            this.dbContext.createRecordWithKey(esWB_Domain)
                .then((newDomainRow: WB_DomainRow)=> {
                    newDomainRow.setDefaults()
                    self.drWB_Domain = newDomainRow;
                    self.dbContext.add(esWB_Domain, newDomainRow)
                    self.Identity.setAll(self.WB_Domain.cif.WB_DOM_ID, self.WB_Domain.cif.DOMAIN_ID, self.WB_Domain.cif.DOMAIN_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_Domain, 'WB_DOM_ID', 'DOMAIN_ID', 'DOMAIN_NAME')

                    self.LoadProgressProvider.finish();
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    resolve(self);

                })
                .catch((err) => {
                    self.LoadProgressProvider.exception(err)
                    error(err)
                })

        });

        return this._OnLoadComplete;
    }

    Load(anId: number | number, options?: object): Promise<IBusinessObject> {

        var self = this;
        if(!this.bIsLoaded)
            this.Identity.setAll( anId, anId,'Loading Domain (' + anId + ')')

        this._OnLoadComplete = new Promise<IBusinessObject>( (resolve, reject) => {

            self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");

            if(self.bIsLoaded) {
                var sError = "Domain already loaded.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                reject(sError);
                return;
            }

            self.LoadOptions = options || {};
            if('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if(this.dbContext == null) {
                var sError = "Unable to determine dbContext for new Domain.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                reject(sError);
                return;
            }

            this.dbContext.find(esWB_Domain,  anId)
                .then((aDomainRow) => {

                    if(_.isEmpty(aDomainRow))
                    {
                        self._OnLoadComplete = null;
                        self.LoadProgressProvider.exception("Id not found.");
                        resolve(self);
                        return;
                    }

                    self.drWB_Domain = aDomainRow;
                    self.Identity.setAll(self.WB_Domain.cif.WB_DOM_ID, self.WB_Domain.cif.DOMAIN_ID, self.WB_Domain.cif.DOMAIN_NAME);
                    self.Identity.listenToRecordUpdates(self.WB_Domain, 'WB_DOM_ID', 'DOMAIN_ID', 'DOMAIN_NAME')
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");

                    // TODO, add in additional child relationships.
                    return (self.drWB_Domain.loadRelations([esWB_Domain_Item,esWB_Domain_Text],
                        self.LoadOptions));
                })
                .then((aDomainRow:any) => {
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.finish();
                    resolve(self);
                })
                .catch(function(err:any){
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.exception(err);
                    reject(err);
                });

        });

        return this._OnLoadComplete;
    }

    addDOMItem(options?: any): Promise<WB_DomainItemRow> {

        const self = this

        return new Promise<WB_DomainItemRow>((resolve, error) => {

            var aDomainItemRow: WB_DomainItemRow = undefined

            self.dbContext.createRecordWithKey(esWB_Domain_Item)
                .then((aNewRow: WB_DomainItemRow) => {
                    aNewRow.setDefaults()
                    aDomainItemRow = aNewRow
                    aDomainItemRow.cif.WB_DOM_ID = self.drWB_Domain.cif.WB_DOM_ID
                    self.dbContext.add(esWB_Domain_Item, aDomainItemRow)
                    resolve(aDomainItemRow)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    removeDOMItem(aDOMItemId: number): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {

            _.forEach(self.drWB_Domain.WB_DomainItemRows, (aDOMItemRelRow: WB_DomainItemRow) => {
                if(aDOMItemRelRow.isActive && aDOMItemRelRow.cif.WB_DOMITEM_ID == aDOMItemId) {
                    aDOMItemRelRow.markDeleted()
                }
            })

            resolve()
        })
    }

    addText(options? : object): Promise<WB_DomainTextRow> {
        const self = this

        return new Promise<WB_DomainTextRow>((resolve, error) => {

            let aDomainTextRow: WB_DomainTextRow = undefined

            self.dbContext.createRecordWithKey(esWB_Domain_Text)
                .then((aNewRow: WB_DomainTextRow) => {
                    aNewRow.setDefaults()
                    aDomainTextRow = aNewRow
                    aDomainTextRow.cif.WB_DOM_ID = self.drWB_Domain.cif.WB_DOM_ID
                    self.dbContext.add(esWB_Domain_Text, aDomainTextRow)
                    resolve(aDomainTextRow)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    removeText(aWbTextId: number): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {

            _.forEach(self.drWB_Domain.WB_DomainTextRows, (aDomainTextRow: WB_DomainTextRow) => {
                if(aDomainTextRow.isActive && aDomainTextRow.cif.WB_DOMT_ID == aWbTextId) {
                    aDomainTextRow.markDeleted()
                }
            })
            resolve()
        })
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }


    Validate(options?: any): Promise<IBusinessObject> {

        var self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start("Validating " + self.WB_Domain.cif.DOMAIN_NAME + "(" + self.WB_Domain.cif.DOMAIN_ID + ")");
        return new Promise<IBusinessObject>( (resolve, reject) => {
            // Does no validations yet
            self.ValidateOptions = options || {};

            if(self.dbContext == null) {
                var sError = "Unable to determine dbContext for to Validate Domain.";
                self.ValidateProgressProvider.exception(sError);
                reject(sError);
            }

            self._bIsValidated = true;
            self.ValidateProgressProvider.finish();
            resolve(self);
        });
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }

    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    private SaveUsing(bBatch: boolean,  options?: any): Promise<IBusinessObject> {

        var self = this;
        var wbDomain = <IwbDomain>self.drWB_Domain;
        this.SaveProgressProvider.start("Saving " + wbDomain.DOMAIN_NAME + "(" + wbDomain.DOMAIN_ID + ")");

        return new Promise<IBusinessObject>( (resolve, reject) => {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // -- We could search the tree if the there is any record where store isn't set.

            if(this.dbContext == null) {
                self._bIsSaved = false;
                var sError = "Unable to determine dbContext to Save Domain.";
                self.SaveProgressProvider.exception(sError);
                reject(sError);
                return
            }
            self.SaveOptions = options || {};

            var saveFunction: (esName: string, saveRecords: ESRecord[]| ESRecord, options?: any) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

            saveFunction(esWB_Domain, self.drWB_Domain,{})
                .then((ignored) => {
                    var tasks: Promise<any>[] = []
                    tasks.push(saveFunction(esWB_Domain_Item, self.drWB_Domain.WB_DomainItemRows))
                    tasks.push(saveFunction(esWB_Domain_Text, self.drWB_Domain.WB_DomainTextRows))
                    return Promise.all(tasks)
                })
                .then((ignored) => {
                    if (bBatch) {
                        self.dbContext.addBatchCompleteListener(()=> {
                            self._bIsSaved = true;
                        })
                    } else {
                        self._bIsSaved = true;
                    }
                    self.SaveProgressProvider.finish();
                    resolve(self);
                })
                .catch((err) => {
                    self.SaveProgressProvider.exception(err);
                    resolve(self)
                })
        });
    }

    get  bIsSaved(): boolean {
        return this._bIsSaved;
    }

    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        var self = this;
        var wbDomain = <IwbDomain>self.drWB_Domain;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + wbDomain.DOMAIN_NAME + "(" + wbDomain.WB_DOM_ID + ")");
        return new Promise<IBusinessObject>( (resolve, error) => {

            // 1. Validate if we can delete the Domain

            // 2. If Valid, mark all the records for deletion.
            self.drWB_Domain.markDeleted()

            if(bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);

                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err)
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }


    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    async Copy(options?: any): Promise<IBusinessObject> {
        const self = this

        const src: DomainBO = this;

        const tgt = new DomainBO({});
        await tgt.LoadNew()

        if(!tgt.bIsLoaded)
            throw new Error("Unable to create New Domain")

        RecordUtils.CopyProperties(tgt.dbContext, esWB_Domain, src.WB_Domain, tgt.WB_Domain,
            [],
            ['DOMAIN_ID', 'DOMAIN_NAME', 'MANUAL_IND', 'INTEGRATION_IND','CREATED_DTTS','MODIFIED_DTTS', 'DELETED_DT', 'DELETED_IND'],
            {})

        tgt.WB_Domain.cif.DOMAIN_ID = "CopyOf" + src.WB_Domain.cif.DOMAIN_ID
        tgt.WB_Domain.cif.DOMAIN_NAME = "Copy of " + src.WB_Domain.cif.DOMAIN_NAME
        tgt.Identity.setAll(tgt.WB_Domain.cif.WB_DOM_ID, tgt.WB_Domain.cif.DOMAIN_ID, tgt.WB_Domain.cif.DOMAIN_NAME);

        for(let aRow of src.WB_Domain.WB_DomainItemRows){
            if(!aRow.isActive)
                continue

            let newDomainItem: WB_DomainItemRow = await tgt.addDOMItem()
            RecordUtils.CopyProperties(tgt.dbContext, esWB_Domain_Item, aRow, newDomainItem,
                [],
                ['WB_DOM_ID',  'MANUAL_IND', 'INTEGRATION_IND','CREATED_DTTS','MODIFIED_DTTS', 'DELETED_DT', 'DELETED_IND'],
                {})
        }

        for(let aRow of src.WB_Domain.WB_DomainTextRows) {
            if (!aRow.isActive)
                continue

            let newDomainText: WB_DomainTextRow = await tgt.addText()
            RecordUtils.CopyProperties(tgt.dbContext, esWB_Domain_Text, aRow, newDomainText,
                [],
                ['WB_DOM_ID',  'MANUAL_IND', 'INTEGRATION_IND','CREATED_DTTS','MODIFIED_DTTS', 'DELETED_DT', 'DELETED_IND'],
                {})

        }


        return tgt
    }

    Changes(options?: IBusinessObjectChangesOptions): IBusinessObjectChanges {
        let opts = options || {}
        opts.dctExcludeFields = opts.dctExcludeFields || {}
        opts.bIgnoreStandardFields = true
        opts.dctIgnoreChanges = opts.dctIgnoreChanges || {}

        // Set any BO Specific change settings
        return DefaultChanges(this, this.drWB_Domain, opts)
    }


    //</editor-fold>

};


PAEnvironment.registerBusinessObjectClass(DomainBO, "DomainBO", "Domain")
